<script>
export default {
    name: 'CoordinatorResourceDocument',
}
</script>
<template>
  <a 
    href="https://docs.google.com/document/d/1GeyR1CBqlzLHOdlPLJt0uA29Z-2ysmTX1dtH9PDmqRo/edit?usp=sharing" 
    target="coordinator-resource"
  >
    <slot>Coordinator Resource Document</slot>
  </a>
</template>